exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".code-guide[data-v-22e13eaf]{background:#fff;border:1px solid #f5f5f5;padding:27px;margin-top:40px}.hd[data-v-22e13eaf]{font-size:14px}.hd span[data-v-22e13eaf]{color:#999;margin-right:4px}.qr-code[data-v-22e13eaf]{width:220px;height:220px;margin:20px auto -5px}", ""]);

// exports
